import {ComplaintStatus} from "@/enums/status";

export class ComplaintParams {
    page? = 1;
    limit? = 10;
    ladingCode?: string;
    fromDate?: number;
    toDate?: number;
    customerRowGuid?: string;
    status? = ComplaintStatus.ChuaXuLy;
    employeeRowGuid?: string;
    createdByRowGuid?: string;
    createdByType?: number;


}
